import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { Button } from 'ui-components/components/button';
import { FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { AliasV3 } from './alias-v3';
import { messages } from './messages';
import sharedStyle from './aliases.module.css';
import { useProductDetailsContext } from '../../../use-product-details-context';

export const ProductDetailsAliasesV3 = () => {
  const { productId, productAliases, setProductAliases } = useProductDetailsContext();

  const onDeleteAlias = useCallback(
    (productAliasId: string) => {
      setProductAliases(productAliases.filter((alias) => alias.productAliasId !== productAliasId));
    },
    [productAliases, setProductAliases],
  );
  const onAddAlias = useCallback(() => {
    const newAlias = {
      storeGuid: undefined,
      aliasSKU: '',
      isNewAlias: true,
      productId,
      productAliasId: String(Math.max(0, ...productAliases.map((a) => Number(a.productAliasId))) + 1),
    };
    setProductAliases([...productAliases, newAlias]);
  }, [setProductAliases, productAliases, productId]);

  return (
    <div className={sharedStyle['aliases-tab']}>
      <div className={sharedStyle['content-card']}>
        <FlexRow style={{ justifyContent: 'flex-end' }}>
          <Button onClick={onAddAlias} theme={THEME_CONSTANTS.secondary}>
            <FontAwesomeIcon icon={faPlus} />
            <FormattedMessage {...messages.addAlias} />
          </Button>
        </FlexRow>
        <div className={sharedStyle['aliases-options']}>
          {productAliases.length > 0 && (
            <div className={sharedStyle['alias-header']}>
              <Text className={sharedStyle['alias-header-sku']} element='div' textType={TextType.Label} value={messages.aliasHeaderSku} />
              <Text
                className={sharedStyle['alias-header-store']}
                element='div'
                textType={TextType.Label}
                value={messages.aliasHeaderStore}
              />
              <Text
                className={sharedStyle['alias-header-actions']}
                element='div'
                textType={TextType.Label}
                value={messages.aliasHeaderActions}
              />
            </div>
          )}
          <div className={sharedStyle['store-alias-list']}>
            {productAliases.length === 0 && (
              <Text
                className={sharedStyle['alias-list-empty']}
                element='div'
                textType={TextType.Paragraph}
                value={messages.aliasesEmptyList}
              />
            )}
            {productAliases.map((alias) => (
              <AliasV3 key={alias.productAliasId} alias={alias} onDeleteAlias={onDeleteAlias} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
